import { render, staticRenderFns } from "./zfbIndex.vue?vue&type=template&id=314dc766&scoped=true"
import script from "./zfbIndex.vue?vue&type=script&lang=js"
export * from "./zfbIndex.vue?vue&type=script&lang=js"
import style0 from "./zfbIndex.vue?vue&type=style&index=0&id=314dc766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314dc766",
  null
  
)

export default component.exports